import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface ConfirmDialogData {
  titleText?: string;
  bodyText?: string;
  confirmText?: string;
  confirmEnabled?: boolean;
  confirmColor?: 'primary' | 'warn';
  cancelText?: string;
  cancelEnabled?: boolean;
  miscText?: string;
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmDialogComponent implements OnInit {
  settings = {
    titleText: 'Confirm Action',
    bodyText: '',
    confirmText: 'Confirm',
    confirmColor: 'primary',
    cancelText: 'Cancel',
    confirmEnabled: true,
    cancelEnabled: true,
    miscText: ''
  };

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {
    if (data) {
      this.settings = {
        ...this.settings,
        ...data
      };
    }
  }

  ngOnInit() {
  }

}
